// extracted by mini-css-extract-plugin
export var attribution = "_cu-4";
export var authorName = "_cu-5";
export var quote = "_cu-3";
export var testimonial = "_cu-2";
export var trustedBy = "_cu-0";
export var trustedByLabel = "_cu-1";